import { EvtSelect } from "components/select";
import { getItemsFromCollection } from "directus/src/operations";
import { useFetch } from "hooks/src/useFetch";
import React from "react";

const SelectApplicant = ({
    openingId,
    className,
    value,
    onChange,
    placeholder = "Select applicant",
    ...props
}) => {
    const { data, isLoading, isError } = useFetch({
        queryKey: ["opening_applicants", openingId],
        queryFn: async () => {
            const filter = openingId ? { opening: { _eq: openingId } } : {};
            const response = await getItemsFromCollection("opening_applicants", {
                fields: ["id", "employee.first_name", "employee.last_name", "employee.id", ],
                limit: -1,
                filter,
            });
            return response.map((item) => {
                const name = `${item.employee?.first_name || ""} ${item.employee?.last_name || ""}`.trim();
                return {
                    name: name || "Unknown",
                    id: item.id,
                };
            });
        },
        enabled: true,
    });

    return (
        <EvtSelect
            data={data}
            isLoading={isLoading}
            className={className}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            type="filter"
            {...props}
        />
    );
};

export default SelectApplicant;
